module.exports = __webpack_public_path__ + "static/media/18ECA35.7c5d754a.jpg";